// import { Button } from 'components'
import React from 'react'

import { CheckboxIcon, ClockIcon, PersonIcon } from '@radix-ui/react-icons'

import { SeatIcon } from '../assets/icons'

const timelineSteps = [
  {
    icon: <ClockIcon className="h-[18px] w-[18px] stroke-2" />,
    title: 'Duration',
    heading: '3 Years',
    description: ['1.5 Year course + 1.5 Year Practical Experience']
  },
  {
    icon: <CheckboxIcon className="h-[18px] w-[18px] stroke-2" />,
    title: 'Eligibility',
    heading: 'Class 12th pass out of last 4 years',
    description: ['Current Students and Passouts']
  },
  {
    icon: <SeatIcon />,
    title: 'Seats',
    heading: '30 Seats',
    subHeading: '(Application Closed)',
    description: ['Extensively selective process']
  },
  {
    icon: <PersonIcon className="h-[18px] w-[18px] stroke-2" />,
    title: 'Mode',
    heading: 'Online',
    description: ['Totally Online College as Future of IT is remote']
  }
]

const TimeLineSection = () => {
  return (
    <section className="md:border-b border-zinc-300">
      <div className="mx-auto px-4 sm:px-6 pb-4 -mt-4 flex flex-col md:flex-row justify-center gap-10 md:gap-0">
        <div className="flex flex-col md:flex-row">
          {timelineSteps.map((step, idx) => (
            <div
              key={idx}
              className="flex flex-col gap-y-2 w-full md:w-48 py-4 border-b border-zinc-300 md:border-r md:border-b-0 md:px-6 first:md:pl-0 first:md:pr-6 md:last:border-r-0">
              <p className="text-base text-black flex items-center gap-x-3">
                {step.icon}
                {step.title}
              </p>
              <h3 className="font-semibold">
                {step.heading}
                {step.subHeading && (
                  <span className="font-normal">{step.subHeading}</span>
                )}
              </h3>
            </div>
          ))}
        </div>
        <div
          className={
            'flex flex-col md:flex-row gap-4 justify-center items-start md:items-center w-[180px]'
          }>
          {/* <div className={'flex flex-col gap-2'}>
            <p className="font-semibold text-2xl">Have queries?</p>
            <p className="text-base text-black flex items-center gap-x-3">
              Join a session with our coFounder at 7pm
            </p>
          </div>
          <a
            target="_blank"
            href="https://lu.ma/event/evt-lANbY696q4TwWPN"
            data-luma-action="checkout"
            className="w-fit"
            data-luma-event-id="evt-lANbY696q4TwWPN"
            rel="noreferrer">
            <Button>Join Session</Button>
          </a> */}
        </div>
      </div>
    </section>
  )
}

export default TimeLineSection
